import type { ComponentProps } from 'react';

import { TextField, theme } from '@theguarantors/tg-package-material-ui';

export type RenterInviteTextInputProps = ComponentProps<typeof TextField>;

export const RenterInviteTextInput = ({ sx, ...props }: RenterInviteTextInputProps) => {
  return (
    <TextField
      color="secondary"
      {...props}
      sx={{
        display: 'flex',
        '& .MuiFormLabel-asterisk': {
          color: 'red !important',
        },
        '& .MuiFormHelperText-root': {
          fontSize: '12px',
          lineHeight: '20px',
        },
        '& .MuiInputLabel-root': {
          [theme.breakpoints.down('md')]: {
            fontSize: '14px !important',
          },
        },
        ...sx,
      }}
    />
  );
};
